export default __webpack_public_path__ + "static/media/H1006.3.cb832709.mp3";